import * as React from 'react'
import { clsx } from 'clsx'
import { PlateElement } from 'platejs/react'
import type { PlateElementProps } from 'platejs/react'

import styles from './HeadingElement.module.css'

type HeadingElementTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type HeadingElementProps = PlateElementProps & { as: HeadingElementTag }

const HeadingElement = React.forwardRef<
  HTMLHeadingElement,
  HeadingElementProps
>(({ as, children, className, ...props }, ref) => (
  <PlateElement
    {...props}
    ref={ref}
    as={as}
    className={clsx(styles.heading, styles[as], className)}
  >
    {children}
  </PlateElement>
))

HeadingElement.displayName = 'RichTextField.HeadingElement'

const H1Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h1" />
)
const H2Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h2" />
)
const H3Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h3" />
)
const H4Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h4" />
)
const H5Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h5" />
)
const H6Element = (props: PlateElementProps): React.ReactElement => (
  <HeadingElement {...props} as="h6" />
)

export {
  H1Element,
  H2Element,
  H3Element,
  H4Element,
  H5Element,
  H6Element,
  HeadingElement,
}
export type { HeadingElementProps, HeadingElementTag }
